import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Col } from "reactstrap";
import { getAllProjects } from "../../services/ValitanApiService";

const ProjectStatus = () => {
    const [statusCounts, setStatusCounts] = useState({});
    const [totalProjects, setTotalProjects] = useState(0);

    useEffect(() => {
        fetchAllProjects();
    }, []);

    const fetchAllProjects = async () => {
        try {
            let allProjects = [];
            let page = 0;
            let size = 100;
            let hasMore = true;

            while (hasMore) {
                const response = await getAllProjects(page, size);
                const content = response?.data?.content || [];
                allProjects = [...allProjects, ...content];

                hasMore = content.length === size;
                page++;
            }

            const grouped = allProjects.reduce((acc, project) => {
                const status = project.status || "UNKNOWN";
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});

            setStatusCounts(grouped);
            setTotalProjects(allProjects.length);
        } catch (error) {
            // ❌ no snackbar here → handled globally in apiClient
            console.error("Error fetching project status:", error);
        }
    };

    const getProgress = (count) => {
        return totalProjects > 0 ? ((count / totalProjects) * 100).toFixed(2) : 0;
    };

    const statusColorMap = {
        IN_PROGRESS: "info",
        COMPLETED: "success",
        PLANNED: "warning",
        CANCELLED: "danger",
        UNKNOWN: "secondary",
    };

    return (
        <React.Fragment>
            <Col md={12} lg={4}>
                <Card className="dashboard-widget">
                    <CardBody>
                        <div className="widget-header">
                            <div>
                                <CardTitle className="widget-title">Project Status</CardTitle>
                                <p className="widget-copy">Distribution of projects by current execution state.</p>
                            </div>
                            <div className="widget-chip">{totalProjects} projects</div>
                        </div>
                        <div className="status-list">
                            {Object.entries(statusCounts).map(([status, count]) => (
                                <div key={status} className="status-item">
                                    <div className="status-item-top">
                                        <span className="status-item-title">{status.replace("_", " ")}</span>
                                        <span className="status-item-count">{count}</span>
                                    </div>
                                    <div className="progress progress-sm animated-progess">
                                        <div
                                            className={`progress-bar bg-${statusColorMap[status] || "secondary"}`}
                                            role="progressbar"
                                            style={{ width: `${getProgress(count)}%` }}
                                            aria-valuenow={getProgress(count)}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default ProjectStatus;
